import React from 'react';

import { createStyles, Theme, withStyles, InputBase, makeStyles, MenuItem } from '@material-ui/core';
import { ColorPalette } from 'theme/colors';

import { FormControl, FormItem, FormItemContainer, Select } from './styles';

export interface Option {
  value: string;
  label: string;
}
export interface Props {
  defaultValue?: string;
  name: string;
  onChange: (value: string) => void;
  options: Option[];
}

const SimpleInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${ColorPalette.HEX.Lotion}`,
      boxShadow: '0 0 20px 0 rgb(51 41 39 / 5%)',
      fontSize: 14,
      padding: '12px 26px 12px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }),
)(InputBase);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    margin: {
      margin: theme.spacing(1),
    },
  }),
);

const FormSelect = ({ defaultValue, name, onChange, options }: Props) => {
  const classes = useStyles();

  return (
    <>
      <FormControl className={classes.margin}>
        <FormItem>
          <FormItemContainer>
            <Select
              name={name}
              defaultValue={defaultValue}
              input={<SimpleInput />}
              onChange={(ev, v) => onChange(`${ev.target.value}`)}
            >
              {options.map((o, k) => (
                <MenuItem key={k} value={o.value}>
                  {o.label}
                </MenuItem>
              ))}
            </Select>
          </FormItemContainer>
        </FormItem>
      </FormControl>
    </>
  );
};
export default FormSelect;
